export const maxDuration = 1440;
